import { makeStyles } from 'tss-react/mui';
import { pickIf } from '../../../utils/pickIf';

export const useStyles = makeStyles()((theme, { detailsMode } = {}) => ({
  container: {
    position: 'relative',
    display: 'flex',
    gap: 10,
    padding: 0,
    [theme.breakpoints.down('lg')]: {
      flexDirection: 'row',
    },
    [theme.breakpoints.down('md')]: {
      marginRight: 0,
      justifyContent: pickIf(!detailsMode, 'center', 'unset'),
      width: '100%',
    },
  },
  countButton: {
    width: pickIf(detailsMode, 130, '50%'),
    maxWidth: 130,
    height: 36,
    [theme.breakpoints.down('lg')]: {
      minWidth: pickIf(detailsMode, 200, 96),
      height: pickIf(detailsMode, 44, 34),
    },
    [theme.breakpoints.down('md')]: {
      minWidth: pickIf(detailsMode, 140, 96),
      height: pickIf(detailsMode, 44, 34),
    },
  },
  addToCartButton: {
    width: pickIf(detailsMode, 130, '50%'),
    maxWidth: pickIf(detailsMode, 'unset', 130),
    height: 36,
    padding: theme.spacing(1),
    [theme.breakpoints.down('lg')]: {
      minWidth: pickIf(detailsMode, 200, 96),
      height: pickIf(detailsMode, 44, 34),
    },
    [theme.breakpoints.down('md')]: {
      width: pickIf(detailsMode, 140, 124),
      minWidth: pickIf(detailsMode, 140, 'unset'),
      maxWidth: pickIf(detailsMode, 'unset', 124),
      height: 32,
    },
  },
}));
